import type { PartnerCockpitOfferRequest } from '@houzy/schemas/partner-cockpit/offer-requests';
import type { TFunction } from 'i18next';

import { formatRelativeTime } from '../../../lib/time';

export function formatOfferRequestSubtitle(t: TFunction, req: PartnerCockpitOfferRequest, now?: Date): string {
    // TODO: distanceKm will be implemented together with partner matching
    const distance =
        req.distanceKm === undefined
            ? t('OFFER_REQUESTS.CARD.DISTANCE_COMING_SOON')
            : t('OFFER_REQUESTS.CARD.DISTANCE', { km: req.distanceKm });
    return t('OFFER_REQUESTS.CARD.SUBTITLE', {
        referenceId: req.referenceId,
        postalCode: req.postalCode,
        city: req.city,
        distance,
        relativeTime: formatRelativeTime(req.matchedAt, t, now),
    });
}
